import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode,
}) => ([
  {
    path: '',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_layout" */ '@/pages/layout');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'layout',
          isLayout: true,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'layout',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'layout',
    index: undefined,
    id: 'layout',
    exact: true,
    exports: ["default"],
    layout: true,
    children: [{
      path: 'livekit/ParticipantTile',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_livekit-participanttile" */ '@/pages/livekit/ParticipantTile');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'livekit/ParticipantTile',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'livekit/ParticipantTile',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'livekit-participanttile',
      index: undefined,
      id: 'livekit/ParticipantTile',
      exact: true,
      exports: ["default"],
    },{
      path: 'voice-call/useVoiceCall',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_voice-call-usevoicecall" */ '@/pages/voice-call/useVoiceCall');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'voice-call/useVoiceCall',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'voice-call/useVoiceCall',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'voice-call-usevoicecall',
      index: undefined,
      id: 'voice-call/useVoiceCall',
      exact: true,
      exports: ["useVoiceCall"],
    },{
      path: 'tele-monitoring',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_tele-monitoring-index" */ '@/pages/tele-monitoring/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'tele-monitoring',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'tele-monitoring',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'tele-monitoring-index',
      index: true,
      id: 'tele-monitoring',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'login-success',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-success-index" */ '@/pages/login-success/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login-success',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login-success',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-success-index',
      index: true,
      id: 'login-success',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'voice-call',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_voice-call-index" */ '@/pages/voice-call/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'voice-call',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'voice-call',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'voice-call-index',
      index: true,
      id: 'voice-call',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'livekit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_livekit-index" */ '@/pages/livekit/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'livekit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'livekit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'livekit-index',
      index: true,
      id: 'livekit',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'success',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_success-index" */ '@/pages/success/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'success',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'success',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'success-index',
      index: true,
      id: 'success',
      exact: true,
      exports: ["default"],
    },{
      path: 'login',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-index',
      index: true,
      id: 'login',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'main',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_main-index" */ '@/pages/main/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'main',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'main',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'main-index',
      index: true,
      id: 'main',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'pad',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pad-index" */ '@/pages/pad/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pad',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pad',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pad-index',
      index: true,
      id: 'pad',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: 'pad/types',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pad-types" */ '@/pages/pad/types');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pad/types',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pad/types',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pad-types',
      index: undefined,
      id: 'pad/types',
      exact: true,
      exports: ["AvoidDirection","ControlType","DoorActionType","DoorLockActionType","HornType","LaneChangeType","LockControlType","RequestType","SpeedControlType","StateType","TOSProceedType","TOSTrafficLightType","TosResponseActions","TurnLightControl","VehiclePowerType"],
    },{
      path: '',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index',
      index: true,
      id: '/',
      exact: true,
      exports: ["default","pageConfig"],
    },{
      path: '*',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_$" */ '@/pages/$');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: '$',
      index: undefined,
      id: '*',
      exact: true,
      exports: ["default"],
    },]
  },{
    path: '/login',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'login-index',
    index: undefined,
    id: '/login',
    exact: true,
    exports: ["default","pageConfig"],
  },{
    path: '/livekit/*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/livekit/*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/livekit/*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: undefined,
    id: '/livekit/*',
    exact: true,
    exports: ["default","pageConfig"],
  },
]);
export default createRoutes;
